/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.VUE_APP_SITECORE_API_KEY || "{99F654E1-2FAE-4DDD-8855-7907758DDA2A}",
config.sitecoreApiHost = process.env.VUE_APP_SITECORE_API_HOST || "https://www.herder.de",
config.sitecoreSiteName = process.env.VUE_APP_SITECORE_SITE_NAME || "H15",
config.layoutServiceConfigurationName = process.env.VUE_APP_LAYOUT_SERVICE_CONFIGURATION_NAME || "default",
config.defaultLanguage = process.env.VUE_APP_DEFAULT_LANGUAGE || "de-DE",
config.graphQLEndpointPath = process.env.VUE_APP_GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge",
config.graphQLEndpoint = process.env.VUE_APP_GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
module.exports = config;